import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  width: 580px;
  height: 100%;
  background: #ffffff;
  border-radius: 8px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
`;

export const Header = styled.div``;

export const Body = styled.div``;

export const TextTitle = styled.p`
  font-family: Inter;
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  text-align: left;
  color: #101828;
`;

export const TextDescription = styled.p`
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 19.36px;
  letter-spacing: 0.05em;
  text-align: left;
  color: #999999;
`;

export const ContentRowCutted = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  gap: 8px;
  width: 100%;
  border: 1px dashed #999999;
  border-radius: 16px;
  cursor: pointer;
  :hover {
    background-color: #f5f5f5;
  }
`;

export const ContentRowCuttedNoAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  gap: 8px;
  width: 100%;
  border: 1px dashed #999999;
  border-radius: 16px;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;

export const SaveButton = styled.button`
  background: linear-gradient(268.28deg, #06d986 0%, #4a76fb 100%);
  border-radius: 16px;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 19.2px;
  text-align: center;
  width: 100%;
  height: 43px;
  color: #ffffff;
  padding: 12px 20px;
  cursor: pointer;
  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ContentDocument = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  gap: 8px;
  width: 100%;
  background-color: #f5f5f5;
  border-radius: 16px;
`;

export const ContentInfoDocument = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  padding: 16px;
  border: 1px solid #2d5bff;
  border-radius: 16px;
`;

export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f4363633;
  border-radius: 8px;
  min-width: 40px;
  min-height: 40px;
  cursor: pointer;
`;

export const TextUpload = styled.p`
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15000000596046448px;
  text-align: left;
  color: black;
  opacity: 87%;
`;

export const SpaceY: any = styled.div`
  height: ${(props: any) => props.space}px !important;
`;
